module.exports = __webpack_public_path__ + "static/media/camera.a09f9223.svg";